<script setup>
import {onMounted, ref, reactive} from "vue";
import router from "@/router/index.js";
import {
  deleteBizCategory,
  listBizCategoryTree,
  updateBizCategorySort,
  updateBizCategoryState
} from "@/api/bizCategory/bizCategory.js";

/*初次加载*/
onMounted(() => {
  handleSearch()
})

/*搜索功能*/
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  try {
    loading.value = true;
    const res = await listBizCategoryTree();
    tableData.value = []
    tableData.value = res
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*表格数据展示*/
const loading = ref(false)
// 表格数据
const tableData = ref([])

/*操作栏功能*/
// 处理添加二级类目
const handleAddSecondary = (item) => {
  router.push({ path: "/editSecondaryCategory", query: { readOnly: 0, fatherBizCategoryId: item.bizCategoryId } })
}
// 处理查看/编辑类目
const handleEditOrReadOnly = (type, item) => {
  if (item.level === 1) {
    if (type === 'readOnly') {
      router.push({ path: "/editPrimaryCategory", query: { readOnly: 1, bizCategoryId: item.bizCategoryId } })
    } else {
      router.push({ path: "/editPrimaryCategory", query: { readOnly: 0, bizCategoryId: item.bizCategoryId } })
    }
  } else if (item.level === 2) {
    if (type === 'readOnly') {
      router.push({ path: "/editSecondaryCategory", query: { readOnly: 1, bizCategoryId: item.bizCategoryId } })
    } else {
      router.push({ path: "/editSecondaryCategory", query: { readOnly: 0, bizCategoryId: item.bizCategoryId } })
    }
  }
}
// 处理下架
const handleUnSale = async (item) => {
  let param = {
    bizCategoryId: item.bizCategoryId,
    state: "OFF_SHELF"
  }
  try {
    loading.value = true
    await updateBizCategoryState(param)
    ElMessage.success("下架成功")
    await handleSearch()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理上架
const handleSale = async (item) => {
  let param = {
    bizCategoryId: item.bizCategoryId,
    state: "ON_SHELF"
  }
  try {
    loading.value = true
    await updateBizCategoryState(param)
    ElMessage.success("上架成功")
    await handleSearch()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理删除类目
const handleDelete = async (item) => {
  try {
    loading.value = true
    await deleteBizCategory(item.bizCategoryId)
    ElMessage.success("删除成功")
    await handleSearch()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*排序相关功能*/
// 处理排序数据并且发起接口请求
const swapSortAndSave = async (current, target) => {
  if (!current || !target) return

  const temp = current.sort
  current.sort = target.sort
  target.sort = temp

  const params = [
    {
      bizCategoryId: current.bizCategoryId,
      sort: current.sort
    },
    {
      bizCategoryId: target.bizCategoryId,
      sort: target.sort
    }
  ]

  await handleBatchSort(params)
  ElMessage.success("排序调整成功")
}
// 过滤表单数据信息，一级类目二级类目分开处理
const getTargetListAndIndex = (item) => {
  const isLevel1 = item.parentId === 0 || item.parentId === "0"
  // 处理一级类目
  if (isLevel1) {
    const list = tableData.value || []
    const index = list.findIndex(i => i.bizCategoryId === item.bizCategoryId)
    return { list, index }
  }
  // 处理二级类目
  const parent = (tableData.value || []).find(i => i.bizCategoryId === item.parentId)
  const list = parent?.children || []
  const index = list.findIndex(i => i.bizCategoryId === item.bizCategoryId)

  return { list, index }
}

// 属性值上移
const handlePropUp = async (item) => {
  try {
    const { list, index } = getTargetListAndIndex(item)

    if (!list.length || index <= 0) {
      ElMessage.warning("已经是第一啦~")
      return
    }

    await swapSortAndSave(list[index], list[index - 1])
  } catch (error) {
    console.error("排序上移失败：", error)
    ElMessage.error("排序调整失败")
  }
}
// 属性值下移
const handlePropDown = async (item) => {
  try {
    const { list, index } = getTargetListAndIndex(item)

    if (!list.length || index === -1) {
      ElMessage.warning("未找到当前类目")
      return
    }

    if (index >= list.length - 1) {
      ElMessage.warning("已经是最后啦~")
      return
    }

    await swapSortAndSave(list[index], list[index + 1])
  } catch (error) {
    console.error("排序下移失败：", error)
    ElMessage.error("排序调整失败")
  }
}
// 处理批量更新商品排序
const handleBatchSort = async (param) => {
  try {
    loading.value = true
    await updateBizCategorySort(param)
    await handleSearch()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*跳转新建*/
const handleAdd = () => {
  router.push("/editPrimaryCategory")
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd">增加一级类目</v-btn>
    </div>
  </div>
  <div class="container_box" v-loading="loading">
    <v-row justify="center">
      <v-col cols="11">
        <el-table
            :data="tableData"
            style="width: 100%; margin-bottom: 20px"
            row-key="bizCategoryId"
            default-expand-all
        >
          <el-table-column prop="type" label="类目类型" width="180">
            <template #default="scope">
              <v-icon color="#409EFF" icon="mdi-folder-open-outline" class="mg_r_1"></v-icon>
              <span v-show="scope.row.level === 1">一级类目</span>
              <span v-show="scope.row.level === 2">二级类目</span>
            </template>
          </el-table-column>
          <el-table-column prop="bizCategoryName" label="类目名称" />
          <el-table-column label="操作" width="300">
            <template #default="scope">
              <el-text class="mx-1 cursor-pointer" type="primary" @click="handleEditOrReadOnly('readOnly', scope.row)">查看</el-text>
              <el-text class="mx-1 cursor-pointer" type="primary" @click="handleEditOrReadOnly('edit', scope.row)">编辑</el-text>
              <el-popconfirm
                  width="288"
                  @confirm="handleUnSale(scope.row)"
                  :title="`${scope.row.level === 1 ? '确认下架该类目及所有下级类目？' : '确认下架该类目？'}`"
              >
                <template #reference>
                  <el-text class="mx-1 cursor-pointer" type="primary" v-show="scope.row.state === 'ON_SHELF'">下架</el-text>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_right">
                    <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="#796CB4" @click="confirm"
                    >确定</v-btn
                    >
                  </div>
                </template>
              </el-popconfirm>
              <el-popconfirm
                  width="288"
                  @confirm="handleSale(scope.row)"
                  :title="`${scope.row.level === 1 ? '确认上架该类目及所有下级类目？' : '确认上架该类目？'}`"
              >
                <template #reference>
                  <el-text class="mx-1 cursor-pointer" type="primary" v-show="scope.row.state === 'OFF_SHELF'">上架</el-text>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_right">
                    <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="#796CB4" @click="confirm"
                    >确定</v-btn
                    >
                  </div>
                </template>
              </el-popconfirm>
              <el-popconfirm
                  width="288"
                  @confirm="handleDelete(scope.row)"
                  :title="`${scope.row.level === 1 ? '确认删除该类目及所有下级类目？该类目及所有下级类目下的商品需要重新分类类目！' : '确认删除该类目？该类目下的商品需要重新分类类目'}`"
              >
                <template #reference>
                  <el-text class="mx-1 cursor-pointer" type="primary">删除</el-text>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_right">
                    <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="#796CB4" @click="confirm"
                    >确定</v-btn
                    >
                  </div>
                </template>
              </el-popconfirm>
              <el-text class="mx-1 cursor-pointer" type="primary" v-show="scope.row.level === 1" @click="handleAddSecondary(scope.row)">添加二级类目</el-text>
            </template>
          </el-table-column>
          <el-table-column label="排序" width="80">
            <template #default="scope">
              <div class="flex_left">
                <v-row>
                  <v-col cols="6">
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="上移"
                        placement="left">
                      <v-icon class="cursor-pointer" @click="handlePropUp(scope.row)" icon="mdi-arrow-up-bold"></v-icon>
                    </el-tooltip>
                  </v-col>
                  <v-col cols="6">
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="下移"
                        placement="right">
                      <v-icon class="cursor-pointer" @click="handlePropDown(scope.row)" icon="mdi-arrow-down-bold"></v-icon>
                    </el-tooltip>
                  </v-col>
                </v-row>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>
